var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-lazy-hydrate',{attrs:{"when-visible":""}},[_c('a-banner',{staticClass:"sidebar__banner",attrs:{"wrapped-in-card":true,"banner-settings":_vm.$options.consts.BANNER_SETTINGS.SIDEBAR.RIGHT_SIDE_2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }